export default function throwIfMissing() {
  throw new Error("Missing parameter");
}
//# sourceMappingURL=throwIfMissing.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/drift-zoom/es/util/throwIfMissing.js
// module id = 157
// module chunks = 0